import { render, staticRenderFns } from "./exchange-email.vue?vue&type=template&id=8b7d2680&scoped=true"
import script from "./exchange-email.vue?vue&type=script&lang=js"
export * from "./exchange-email.vue?vue&type=script&lang=js"
import style0 from "./exchange-email.vue?vue&type=style&index=0&id=8b7d2680&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7d2680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b7d2680')) {
      api.createRecord('8b7d2680', component.options)
    } else {
      api.reload('8b7d2680', component.options)
    }
    module.hot.accept("./exchange-email.vue?vue&type=template&id=8b7d2680&scoped=true", function () {
      api.rerender('8b7d2680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/exchange-email.vue"
export default component.exports